import {createSlice} from "@reduxjs/toolkit";
import {fetchNavbars} from "./globalComponentsThunks";

export const navbarsRepoSlice = createSlice({
    name: 'navbarsRepo',
    initialState: {
        navbarsRepo: [],
        loading: true,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNavbars.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNavbars.fulfilled, (state, action) => {
                state.loading = false;
                state.navbarsRepo = action.payload;
            })
            .addCase(fetchNavbars.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export default navbarsRepoSlice.reducer;